﻿

const targets = document.querySelectorAll('[data-animation-intersection]');

const intersectionObserverOptions = {
  root: null,
  rootMargin: '0px',
  threshold: [0.0, 0.5]
};

const observer = new IntersectionObserver(onIntersection, intersectionObserverOptions);

function onIntersection(entries) {
  entries.forEach(entry => {
	let options = JSON.parse(entry.target.dataset.animationIntersection);

	if (entry.isIntersecting) {

	  options.classes.forEach((cssClass) => {
		entry.target.classList.remove('invisible');
		entry.target.classList.add('animate__animated');
		entry.target.classList.add(cssClass);
	  });

	} else {
	  if (options.infinite) {
		options.classes.forEach((cssClass) => {
		  entry.target.classList.add('invisible');
		  entry.target.classList.remove('animate__animated');
		  entry.target.classList.remove(cssClass);
		});
	  } else {
		entry.target.classList.add('invisible');
	  }
	}

  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
	for (let i = 0; i < targets.length; i++) {
	  observer.observe(targets[i]);
	}
  }, 100);
});